/*
 * Copyright (c) 2020 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { UserContext } from '@irian-ro/util-user';

//const starting in uppercase in order to have the same API as with classes
export const AuthEmailNullReferenceGuard: CanActivateFn = () => {
  const userContext = inject(UserContext, { optional: true });
  const router = inject(Router);
  const whitelistAuthType = 'authUser';

  if (!userContext) {
    throw new Error('Provide UserContext in app.module');
  }

  return userContext.getCurrentUser().pipe(
    take(1),
    map((loggedInUser) => {
      if (loggedInUser.authType && loggedInUser.authType === whitelistAuthType) {
        if (!loggedInUser.email) {
          return router.parseUrl(`/profile/` + loggedInUser.uuid);
        } else {
          return true;
        }
      } else {
        return true;
      }
    })
  );
};
